<template>
  <div>
    <el-table :data="tableData" style="width: 100%" border v-loading="loading">
      <el-table-column type="index" label="序号"> </el-table-column>
      <el-table-column prop="contactName" label="联系人"> </el-table-column>
      <el-table-column prop="contactPhone" label="联系电话"> </el-table-column>
      <el-table-column prop="gender" label="性别">
        <template slot-scope="scope">
          {{ scope.row.gender | genderFilter(genderOptions) }}
        </template>
      </el-table-column>
      <el-table-column prop="city" label="市"> </el-table-column>
      <el-table-column prop="addressDetail" label="详细地址"> </el-table-column>
      <el-table-column prop="location" label="经纬度"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { querySubscriberContactPageApi } from "@/api/subscriber";
export default {
  name: "SubscriberContact",
  props: {
    subscriberId: {
      type: String,
      default: undefined
    }
  },
  filters: {
    genderFilter(value, options) {
      let item = options.find(item => item.value == value);
      return item ? item.label : "未知";
    }
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      genderOptions: [
        { label: "男", value: 1 },
        { label: "女", value: 2 },
        { label: "未知", value: 0 }
      ],
      tableData: [],
      loading: false
    };
  },
  watch: {
    subscriberId: {
      immediate: true,
      handler(val) {
        if (!val) {
          return;
        }
        this.subscriberId = val;
        this.loadPage(1);
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.loading = true;
      querySubscriberContactPageApi(this.subscriberId, this.searchForm)
        .then(res => {
          if (res.data.status == 100) {
            this.tableData = res.data.results.list;
            this.searchForm.total = res.data.results.total;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      this.searchForm.pageNum = val;
      this.loadPage();
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.loadPage();
    }
  }
};
</script>



// WEBPACK FOOTER //
// subscriberContact.vue?c518ead8